<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-s-tools"></i> GM 相关</el-breadcrumb-item>
                <el-breadcrumb-item>{{ postOrUpdate.content }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <el-page-header @back="goBack" :content="postOrUpdate.content"></el-page-header>
            <el-divider></el-divider>
            <div style="border: 1px solid #ccc; border-radius: 6px ; width: 70%;">
                <el-form :model="form" :rules="rules" ref="noticeForm" label-width="0px" class="ms-content">
                    <el-form-item prop="title">
                        <el-input placeholder="请输入标题" v-model="form.title" :disabled="postOrUpdate.flag">
                            <template slot="prepend">公告标题</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="content">
                        <el-input
                            :disabled="postOrUpdate.flag"
                            style="margin-top: 15px"
                            type="textarea"
                            :rows="28"
                            placeholder="请输入内容"
                            v-model="form.content">
                        </el-input>
                    </el-form-item>
                    <div class="register-btn">
                        <el-button type="primary" @click="onSubmit('noticeForm')" style="margin-left: 85%; margin-bottom: 10px;" v-show="!postOrUpdate.flag"> 提交公告</el-button>
                    </div>
                </el-form>

                <!-- <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                />
                <Editor
                    style="height: 500px; overflow-y: hidden;"
                    v-model="html"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                /> -->
            </div>
        </div>
    </div>
    
</template>

<script>
// 导入富文本编辑器
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
// Api
import { postMarsNotice, getMarsNotice } from '../../api/gameconsole-mars.js'
export default {
    name: 'Notice',
    components: { Editor, Toolbar },
    data: function(){
        return {

            //动态路由 参数
            id: undefined, 
            //标识新增 还是 修改
            postOrUpdate: {
                title: '提交公告',
                content : '新增公告',
                flag: false
            },
            form: {
                title: '',   //公告标题
                content: ''  //公告内容
            },
            html: '',  // 展示框内容

            //表单验证
            rules: {
                title: [
                    { required: true, message: '标题不能为空', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '内容不能为空', trigger: 'blur' },
                ],
            },

        }
    },
    mounted() {
        //如果 传值了id，就调用 编辑公告 函数， 否则 新增公告
        this.id = localStorage.getItem('noticeId')
        this.initData()
    },
    activated() {
        let id = localStorage.getItem('noticeId')
        //如果 传值了id，就调用 编辑公告 函数， 否则 新增公告
        if (id != undefined && id != 'undefined') {
            this.postOrUpdate.content = '公告详细'  //将 新增公告 替换成 公告详细
            this.postOrUpdate.flag = true        //隐藏 提交公告 按钮
            this.id = id
            this.initData()
        } else {
            this.postOrUpdate.content = '新增公告'  //将 新增公告 替换成 公告详细
            this.postOrUpdate.flag = false        //隐藏 提交公告 按钮
        }

        //清空编辑框
        this.form.title = ''
        this.form.content = ''
    },
    methods: {
        //
        initData() {
            let params = {'id': this.id, 'pageIndex': 1, 'pageSize': 1}
            getMarsNotice(params).then(res => {
                if (res.data.code == 200) {
                    this.form.content = res.data.data.records[0].content
                    this.form.title = res.data.data.records[0].title
                }
            })
        },

        //提交按钮
        onSubmit(noticeForm) {
            this.$refs[noticeForm].validate((valid) => {
                if (valid) {
                    let userId = localStorage.getItem('userId')
                    //发送请求
                    let params = {'creatorId': userId, 'title': this.form.title, 'content': this.form.content, 'noticeShow': 0 }  //isShow  0:隐藏 1:显示
                    postMarsNotice(params).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message)
                            this.$router.push('/Gameconsole')
                        }
                    })
                }
            })
        },

        //返回上一页
        goBack() {
            this.$router.push('/Gameconsole')
        },

        // onCreated(editor) {
        //     this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        // },
    }
}
</script>

<style scoped lang="scss">

</style>